import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { ChipCheckerResults, PetService } from 'src/app/services/pet/pet.service';

@Component({
  selector: 'app-chip-checker',
  templateUrl: './chip-checker.component.html',
  styleUrls: ['./chip-checker.component.scss'],
})
export class ChipCheckerComponent implements OnInit {
  chipCheckerLoading = false;
  chipCheckerResults: ChipCheckerResults = null;
  chipCheckerNumber: string;
  @Input()
  variant: string;
  isBrowser: boolean;

  constructor(
    private petService: PetService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {}

  trackEvent(event: string) {
    if (!this.isBrowser) return;
    window.analytics.track(event);
  }

  checkChip() {
    this.trackEvent('homepage::checkachip::clicked');
    this.chipCheckerLoading = true;
    this.chipCheckerResults = null;
    this.petService
      .checkChip(this.chipCheckerNumber)
      .subscribe((results) => {
        this.chipCheckerResults = results;
      })
      .add(() => {
        this.chipCheckerLoading = false;
      });
  }
}
